module.exports = "mutation ($data: ModelTemplateCreate!) {\n  ModelTemplateCreate(data: $data) {\n    id\n  }\n}\n"